import { render, staticRenderFns } from "@/modules/Label/templates/labels-list.html?vue&type=template&id=20c23f0d&scoped=true&"
import script from "@/modules/Label/scripts/labels-list.ts?vue&type=script&lang=js&"
export * from "@/modules/Label/scripts/labels-list.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Label/styles/labels-list.scss?vue&type=style&index=0&id=20c23f0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c23f0d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VForm,VImg,VTooltip})
